module.exports = __webpack_public_path__ + "static/media/SoLogo.2cf640bd.png";